export default __webpack_public_path__ + "static/media/legend_water_extraction_plants.2b839ae7.png";